import { Row } from '@tanstack/react-table'

import { Log } from '@/types/logs'
import { sortLogsByTime } from './sortLogsByTime'
import { compareValueWithPrefix, extractParts } from '@/helpers/compareValueWithPrefix'

const collator = new Intl.Collator(undefined, { numeric: true, sensitivity: 'base' })

export const sortLogsBy =
    (columnId: keyof Log, shouldBeLast?: (log: Log) => boolean) =>
    (logA: Row<Log>, logB: Row<Log>): number => {
        const isALast = shouldBeLast?.(logA.original)
        const isBLast = shouldBeLast?.(logB.original)

        if (isALast && !isBLast) {
            return 1
        }

        if (!isALast && isBLast) {
            return -1
        }

        if (isALast && isBLast) {
            return sortLogsByTime(logA.original, logB.original)
        }

        const valueA = Array.isArray(logA.original[columnId]) ? logA.original[columnId] : [logA.original[columnId]]
        const valueB = Array.isArray(logB.original[columnId]) ? logB.original[columnId] : [logB.original[columnId]]

        const sortedValuesA = [...valueA].sort(collator.compare)
        const sortedValuesB = [...valueB].sort(collator.compare)

        const maxLength = Math.max(sortedValuesA.length, sortedValuesB.length)

        if (
            sortedValuesA.length === sortedValuesB.length &&
            sortedValuesA.every((item, index) => sortedValuesB[index] === item)
        ) {
            return sortLogsByTime(logA.original, logB.original)
        }

        for (let i = 0; i < maxLength; i++) {
            const a = sortedValuesA[i] ?? ''
            const b = sortedValuesB[i] ?? ''

            const [prefixA, numA, suffixA] = extractParts(a)
            const [prefixB, numB, suffixB] = extractParts(b)

            const comparison = compareValueWithPrefix([prefixA, numA, suffixA], [prefixB, numB, suffixB])
            if (comparison !== 0) return comparison
        }

        return sortLogsByTime(logA.original, logB.original)
    }
